import React from 'react';

const ReviewPageIntroduction = () => {
  return (
    <div className="vads-u-margin-bottom--4">
      <h2 className="vads-u-font-size--h3">Review your information</h2>
      <p>
        Check your answers by expanding the sections below. You can edit any of
        your answers directly on this page.
      </p>
    </div>
  );
};

export default ReviewPageIntroduction;
